import React from 'react';
import {
  Plus, PlusCircle, Trash2, Loader2, Check, CheckCircle2, CheckSquare,
  X, XCircle, Users, ListChecks, Clock, School, SquarePen, Book, BookOpen,
  Search, GraduationCap, Settings, HelpCircle, Sparkles, AlertCircle,
  AlertTriangle, UploadCloud, Image, BarChart3, LineChart, PieChart,
  Shield, Wrench, Lightbulb, Medal, Presentation, ArrowRight, ArrowLeft,
  RotateCw, RefreshCw, Volume2, Copy, Quote, ChevronLeft, ChevronRight,
  Heart, Keyboard, Brain, VenetianMask, UserRound, CalendarDays, Lock,
  LogOut, FolderOpen, Crosshair, Expand, Send, Layers, Camera, Info,
  Star, Coins,
} from 'lucide-react';

/**
 * 🟢 [图标升级] 通用功能图标（Lucide SVG，替换 FontAwesome）
 *
 * 关键点：以 size="1em" 渲染并使用 currentColor，因此调用处原有的
 * text-2xl / text-white / text-red-500 等 Tailwind 类可以继续控制图标的
 * 大小与颜色，做到近乎「原地替换」。功能性小图标（关闭/编辑/加载/箭头等）
 * 用这个；导航与大卡片的主题图标用带渐变的 <GradientIcon />。
 *
 * 用法：<AppIcon name="trash-alt" className="text-red-500" />
 */

// FontAwesome 名称 → Lucide 组件
const MAP = {
  'plus': Plus,
  'plus-circle': PlusCircle,
  'trash-alt': Trash2,
  'spinner': Loader2,
  'circle-notch': Loader2,
  'check': Check,
  'check-circle': CheckCircle2,
  'check-square': CheckSquare,
  'times': X,
  'times-circle': XCircle,
  'users': Users,
  'tasks': ListChecks,
  'clock': Clock,
  'school': School,
  'edit': SquarePen,
  'book': Book,
  'book-open': BookOpen,
  'search': Search,
  'graduation-cap': GraduationCap,
  'cog': Settings,
  'question-circle': HelpCircle,
  'magic': Sparkles,
  'exclamation-circle': AlertCircle,
  'exclamation-triangle': AlertTriangle,
  'cloud-upload-alt': UploadCloud,
  'image': Image,
  'chart-bar': BarChart3,
  'chart-line': LineChart,
  'chart-pie': PieChart,
  'shield-alt': Shield,
  'tools': Wrench,
  'lightbulb': Lightbulb,
  'medal': Medal,
  'chalkboard-teacher': Presentation,
  'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft,
  'redo-alt': RotateCw,
  'sync-alt': RefreshCw,
  'volume-up': Volume2,
  'clone': Copy,
  'quote-left': Quote,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'heart': Heart,
  'keyboard': Keyboard,
  'brain': Brain,
  'user-secret': VenetianMask,
  'user-tie': UserRound,
  'calendar-alt': CalendarDays,
  'lock': Lock,
  'sign-out-alt': LogOut,
  'folder-open': FolderOpen,
  'crosshairs': Crosshair,
  'expand': Expand,
  'paper-plane': Send,
  'layer-group': Layers,
  'camera': Camera,
  'info-circle': Info,
  'star': Star,
  'coins': Coins,
};

// 需要旋转的加载类图标
const SPIN = new Set(['spinner', 'circle-notch']);

const AppIcon = ({ name, className = '', strokeWidth = 2.2, ...rest }) => {
  const Cmp = MAP[name] || HelpCircle;
  const spin = SPIN.has(name) ? ' animate-spin' : '';
  return (
    <Cmp
      size="1em"
      strokeWidth={strokeWidth}
      className={`inline-block align-[-0.125em] shrink-0${spin} ${className}`.trim()}
      aria-hidden="true"
      {...rest}
    />
  );
};

export default AppIcon;
